import { MemberSearchResultDto, WorkflowDto, MemberDto, DependantDto, MembershipDto, TicketModeEnum } from '../../../service/dto';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpWorkflowService } from '../../../service/http-workflow.service';
import { finalize, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpTicketService } from '../../../service/http-ticket.service';
import { environment } from '../../../../environments/environment';

class WrapperMemberSearchResultDto {
	payload!: MemberDto;
	dependents!: DependantDto[];
	memberships!: WrapperMemberSearchResultMembershipDto[];
	expanded!: boolean;
	checked = false;
	indeterminate = false;
	setOfCheckedId = new Set<number>();
}
class WrapperMemberSearchResultMembershipDto {
	payload!: MembershipDto;
	selected!: boolean;
}




@Component({
	selector: 'app-ticket-member-search',
	standalone: false,
	templateUrl: './ticket-member-search.component.html',
	styleUrl: './ticket-member-search.component.scss'
})
export class TicketMemberSearchComponent implements OnInit, OnDestroy {
	ticketMode!: TicketModeEnum;
	workflows!: WorkflowDto[];
	workflow?: WorkflowDto;


	searchForm!: FormGroup;

	results?: WrapperMemberSearchResultDto[];
	loading = false;
	subscription = new Subscription();

	constructor(
		private fb: FormBuilder,
		private ticketService: HttpTicketService,
		private activatedRoute: ActivatedRoute,
		private router: Router) {
		this.searchForm = this.fb.group({
			search: ['', Validators.required]
		});
	}

	ngOnInit(): void {
		this.subscription.add(this.activatedRoute.params.subscribe(params => {
			this.ticketMode = params['ticketMode']!;
			this.loading = true;
			this.ticketService.getWorkflows(this.ticketMode).pipe(
				finalize(() => {
					this.loading = false;
				})
			).subscribe(result => this.workflows = result);
		}));
	}
	ngOnDestroy(): void {

	}
	doSearch() {
		this.ticketService.search(this.searchForm.get('search')!.value).subscribe(result => {
			this.results = result.results.map(item => {
				return {
					payload: item.member,
					dependents: item.member.dependants,
					memberships: item.member.memberships.map(i => { return { payload: i, selected: false } }),
					checked: false,
					indeterminate: false,
					setOfCheckedId: new Set<number>(),
					expanded: true
				};
			});
		});
	}

	get memberTicketRequiredCategory(): boolean {
		return environment.createMemberTicketWithoutCategory;
	}

	canCreateMemberTicket(input: WrapperMemberSearchResultDto): boolean {
		if (!this.workflow) {
			return false;
		}
		if (this.memberTicketRequiredCategory == true) {
			return input.setOfCheckedId.size > 0;
		}
		return true;
	}
	canCreateDependantTicket(input: WrapperMemberSearchResultDto): boolean {
		if (!this.workflow) {
			return false;
		}
		return true;
	}
	startTicketForMember(input: WrapperMemberSearchResultDto) {
		if (input.setOfCheckedId.size == 0) {
			this.router.navigate(['/ticket', this.workflow!.ticketMode, this.workflow!.id, 'member', input.payload.id]);
		} else {
			const categories = Array.from(input.setOfCheckedId).join(',');
			this.router.navigate(['/ticket', this.workflow!.ticketMode, this.workflow!.id, 'member', input.payload.id, categories]);
		}
	}
	startTicketForDependant(input: DependantDto) {
		this.router.navigate(['/ticket', this.workflow!.ticketMode, this.workflow!.id, 'dependent', input.id]);
	}
	onAllChecked(member: WrapperMemberSearchResultDto, selected: boolean) {
		member.memberships.forEach(item => this.updateCheckedSet(member, item, selected));
		this.refreshCheckedStatus(member);
	}
	onItemChecked(member: WrapperMemberSearchResultDto, membership: WrapperMemberSearchResultMembershipDto, checked: boolean): void {
		this.updateCheckedSet(member, membership, checked);
		this.refreshCheckedStatus(member);
	}
	updateCheckedSet(member: WrapperMemberSearchResultDto, membership: WrapperMemberSearchResultMembershipDto, checked: boolean): void {
		if (checked) {
			member.setOfCheckedId.add(membership.payload.id);
		} else {
			member.setOfCheckedId.delete(membership.payload.id);
		}
	}
	refreshCheckedStatus(member: WrapperMemberSearchResultDto): void {
		member.checked = member.memberships.every(item => member.setOfCheckedId.has(item.payload.id));
		member.indeterminate = member.memberships.some(item => member.setOfCheckedId.has(item.payload.id)) && !member.checked;
	}
}
